module.exports = __webpack_public_path__ + "img/Rupeezy (1).42179508.svg";